<template>
  <div>
    <el-form class="el-form-m20" :inline="true" size="small" :model="condition">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}" v-model="condition.name"
                  placeholder="请输入课程名称">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item v-if="normal">
        <el-button-group>
          <!--                    <el-button type="primary" icon="el-icon-s-fold">分配视频</el-button>-->
          <el-button v-if="perm.indexOf('course:allot') > -1" type="primary" icon="el-icon-set-up"
                     @click="dialogVideoVisible=true">分配视频
          </el-button>
          <el-button v-if="perm.indexOf('course:insert') > -1" type="primary"
                     icon="el-icon-circle-plus-outline"
                     @click="createRow">新建课程
          </el-button>
          <el-button v-if="perm.indexOf('course:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="courseTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="id"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="id" label="编号" width="100">
      </el-table-column>
      <el-table-column prop="name" label="课程名" width="160">
      </el-table-column>
      <el-table-column prop="period" label="学时" width="100">
      </el-table-column>
      <el-table-column prop="openClass" label="公开课" width="100" :formatter="openClassFormat">
      </el-table-column>
      <el-table-column prop="teacher" label="讲师姓名" width="120">
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="intro" label="简介">
      </el-table-column>
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('course:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改
          </el-link>
          <el-link v-if="scope.row.hasVideo"
                   type="primary"
                   icon="el-icon-view"
                   @click="showDetails(scope.$index, scope.row)">查看视频
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog v-if="normal && (perm.indexOf('course:insert') > -1 || perm.indexOf('course:update') > -1)"
               @close="cancelForm" :title="title" width="40%" :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <el-form ref="courseForm" :show-message="false" :model="form" label-position="right" label-width="80px">
        <el-form-item prop="name" label="课程名" :required="true">
          <el-input v-model="form.name" placeholder="请输入课程名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="teacher" label="讲师" :required="true">
          <el-input v-model="form.teacher" placeholder="请输入讲师姓名"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="period" label="学时" :required="true">
          <el-input-number v-model="form.period" placeholder="请输入学时"
                           autocomplete="off"></el-input-number>
        </el-form-item>
        <el-form-item prop="openClass" label="公开课">
          <el-switch
              v-model="form.openClass"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item prop="intro" label="课程简介" :required="true">
          <el-input :rows="6" maxlength="120" show-word-limit type="textarea" v-model="form.intro"
                    placeholder="请输入课程简介"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="normal && perm.indexOf('course:allot') > -1" :visible.sync="dialogVideoVisible" @close="cs"
               @opened="$refs['video'].getList()">
      <cz-video ref="video" :normal="false" @rowSelected="rowSelection"></cz-video>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" @click="dialogVideoVisible=false">取 消</el-button>
          <el-button size="small" icon="el-icon-s-fold" @click="appendVideo">追加视频</el-button>
          <el-button size="small" icon="el-icon-setting" @click="resetVideo">重新分配视频
          </el-button>
        </el-button-group>
      </div>
    </el-dialog>
    <el-dialog title="已分配的视频" v-if="normal" :visible.sync="dialogDetailsVisible" @close="curVideoList=[]">
      <el-tag v-for="item in curVideoList" :key="item.id" :closable="perm.indexOf('course:delete') > -1"
              @close="removeVideoFromCourse(item.id)">{{ item.name }}
      </el-tag>
    </el-dialog>
  </div>
</template>

<script>
import CzVideo from "./Video";
import helper from "../common/CZHelper";

export default {
  name: "Course",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CzVideo
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/course/",
      title: '',
      dialogFormVisible: false,
      dialogVideoVisible: false,
      dialogDetailsVisible: false,
      perm: localStorage.getItem('perm').split(","),
      crtSelectionList: [],
      courseId: 0,
      curVideoList: [],
      condition: {
        name: null,
        teacher: null,
        period: null
      },
      form: {
        name: null,
        teacher: null,
        period: null,
        intro: null,
        openClass: 0
      },
      list: [],
      total: 0,
      size: this.normal ? 10 : 6,
      index: 1,
      dlgSelectionList: []
    }
  },
  created() {
    /*this.getList();*/
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getList();
    });
  },
  methods: {
    removeVideoFromCourse(vid) {
      this.$axios.get(this.apiUrl + "removeVideo",
          {
            params: {courseId: this.courseId, videoId: vid}
          })
          .then(({data}) => {
            if (data.code === 200) {
              this.curVideoList = this.curVideoList.filter((v) => v.id !== vid);
              if (this.curVideoList.length <= 0) {
                this.dialogDetailsVisible = false;
                this.getList();
              }
            }
          });
    },
    tableRowClassName({row, rowIndex}) {
      if (row.openClass) {
        return 'success-row';
      }
      return '';
    },
    openClassFormat(row, column, cellValue, index) {
      return cellValue ? 'Y' : 'N';
    },
    appendVideo() {
      this.allotCourse("append");
    },
    showDetails(index, row) {
      this.dialogDetailsVisible = true;
      this.courseId = row.id;
      // this.curVideoList = row.vodList;
      this.$axios.get(
          this.apiUrl + "details?courseId=" + row.id
      ).then(({data}) => {
        this.curVideoList = JSON.parse(data.message);
      });
    },
    resetVideo() {
      this.allotCourse("reset");
    },
    allotCourse(target) {
      if (this.crtSelectionList.length <= 0) {
        this.$message.warning('请选择课程');
        return;
      }
      if (this.dlgSelectionList.length <= 0) {
        this.$message.warning('请选择视频');
        return;
      }
      let courseIds = this.crtSelectionList.map(item => item.id);
      let videoId = this.dlgSelectionList.map(item => item.id);
      this.$axios.post(
          this.apiUrl + target,
          {
            courseIds: courseIds.join(","),
            videoIds: videoId.join(",")
          }
      ).then(response => {
        if (response.data.code === 200) {
          this.$message.success('分配课程成功');
          this.cs();
          this.getList();
        } else {
          this.$message.error('分配课程失败');
        }
        this.dialogVideoVisible = false;
      });
    },
    rowSelection(rows) {
      // 选择视频回调
      if (!rows.length) return;
      this.dlgSelectionList = rows;
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    // 内部清除选择
    cs() {
      this.crtSelectionList = [];
      if (this.$refs['video']) this.$refs['video'].cs();
      this.$refs['courseTable'].clearSelection();
    },
    querySearch(queryString, cb) {
      // 只能用{value:***}的对象数组才能看到结果，简单数组看不到结果
      let school = this.school.map((v, i) => {
        return {value: v}
      });
      let results = queryString ? school.filter(
          (item) => {
            return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
      ) : school;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelectionChange(val) {
      if (!this.normal) this.$emit("rowSelected", val);
      this.crtSelectionList = val;
    },

    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.crtSelectionList.length <= 0) return;
        let ids = [];
        this.crtSelectionList.map((v, i) => ids.push(v.id));
        this.$axios.post(
            this.apiUrl + "remove",
            {
              ids: ids.join(",")
            }
        ).then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.cs();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    createRow() {
      this.index = 1;
      this.show('添加课程');
    },
    modifyRow(rowIndex, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.show('修改课程');
    },
    show(title) {
      this.dialogFormVisible = true;
      this.title = title;
      if (this.$refs['courseForm']) this.$refs['courseForm'].clearValidate();
    },
    cancelForm() {
      this.dialogFormVisible = false;
      this.form = {school: null, crName: null, college: null, openClass: 0};
    },
    confirmForm() {
      this.$refs['courseForm'].validate((valid) => {
        if (valid) {
          let postUrl = this.form.id ? 'modify' : 'add';
          postUrl = this.apiUrl + postUrl;
          this.$axios.post(postUrl, this.form).then(response => {
            if (response.data.code === 200) {
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error('操作失败');
            }
            this.cancelForm();
          });
        } else {
          return false;
        }
      });
    },
    search() {
      this.index = 1;
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        course: JSON.stringify(this.condition)
      };
      helper.getList(this.apiUrl + 'list', params, this);
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.el-table th, .el-table td {
  padding: 5px 0;
}

.el-tag {
  margin: 0 5px 5px;
}

.el-link {
  margin: 0 5px;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.school {
  color: #9f9f9f;
  width: 78px;
}

.filter {
  display: flex;
  color: #e79b37;
  padding: 10px 0 10px 25px;
  font-size: 0.9em;
  background: white;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-item-active {
  color: #8b0000;
}


.filter-item {
  margin: 0 10px;
  cursor: pointer;
}

</style>